import { agenciesConstants } from '../constants/agencies';
import { agencies } from '../services/ApiService';

export const setAgencyStatus = (id, status = null, agencyType) => ({
  type: agenciesConstants.SET_AGENCY_STATUS,
  id,
  status,
  agencyType,
});

export const setAgencies = (agencies = []) => ({
  type: agenciesConstants.SET_AGENCIES_SUCCESS,
  agencies,
});

export const startSetAgencies = () => dispatch =>
  agencies
    .getList()
    .then((data = {}) => dispatch(setAgencies(data.items)))
    .catch(e => dispatch({ type: agenciesConstants.SET_AGENCIES_FAILURE }));

export const setWebmasterAgencies = (agencies = [], purses = {}) => ({
  type: agenciesConstants.SET_WM_AGENCIES_SUCCESS,
  agencies,
  purses,
});

export const startSetWebmasterAgencies = () => dispatch =>
  agencies
    .getList({ type: 'pay' })
    .then((data = {}) => dispatch(setWebmasterAgencies(data.items, data.purses)))
    .catch(e => dispatch({ type: agenciesConstants.SET_WM_AGENCIES_FAILURE }));

export const setPayments = (payments = [], count = 0) => ({
  type: agenciesConstants.SET_PAYMENTS_LOG_SUCCESS,
  payments,
  count,
});

export const startSetPayments = params => dispatch =>
  agencies
    .getPaymentsList(params)
    .then((data = {}) => dispatch(setPayments(data.items, data.count)))
    .catch(err => dispatch({ type: agenciesConstants.SET_PAYMENTS_LOG_FAILURE }));

export const setPromocode = (id, code) => ({
  type: agenciesConstants.SET_AGENCY_PROMOCODE,
  id,
  code,
});

export const startSetPromocode = id => dispatch =>
  agencies
    .getPersonalPromocode(id)
    .then((data = { items: [{ code: '' }] }) => dispatch(setPromocode(id, data.items[0].code)));

export const setRedirectToAgenciesData = agencyId => ({
  type: agenciesConstants.SET_REDIRECT_TO_AGENCIES_DATA,
  agencyId,
});

export const clearRedirectToAgenciesData = () => ({
  type: agenciesConstants.CLEAR_REDIRECT_TO_AGENCIES_DATA,
});
